module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BnAmbG/tc-custom/9781588169167.jpg?1729082652120",
      "alt": "This image is the cover for the book Country Living Simple Country Wisdom"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Country Living Simple Country Wisdom\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a leading American lifestyle magazine, advice and tips to easily create a clean, organized, relaxing, and inviting home—includes photos.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Has life become a bundle of stress and mess? Top-selling author Susan Waggoner has the solution. This ingenious, fun-to-read illustrated guide offers tried-and-true household hints and practical solutions to everyday problems, from the “A-to-Z Guide to Food” to “The Tao of Laundry.” Whether it's a no-scrub trick to make bathroom faucets gleam or surefire advice on keeping your house harmonious with as little fuss as possible, "), _c('i', [_vm._v("Country Living Simple Country Wisdom")]), _vm._v(" is the key to creating a home that's cheerful, welcoming, and warm."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susan Waggoner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Sterling Publishing Co., Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0